import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Offers from "./pages/Offers";
import Contact from "./pages/Contact";
import Navbar from "./components/Navbar";
import BackgroundAnimation from "./components/BackgroundAnimation";
import Footer from "./components/Footer";
import SafetyTips from "./pages/SafetyTips";
import AboutUs from "./pages/AboutUs";
import ScrollToTop from "./components/ScrollToTop";
import Cart from "./pages/Cart";
import { CartProvider } from "./context/CartContext";


function App() {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false); // hide after 10 seconds
    }, 20000); // 10,000ms = 10s

    return () => clearTimeout(timer);
  }, []);

  return (
    <CartProvider>
      <Router>
        {showAnimation && <BackgroundAnimation />}
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/safety-tips" element={<SafetyTips />} />
          <Route path="/cart" element={<Cart />} />  {/* Add cart route */}
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
